import React, { useRef, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { isEmpty } from 'lodash';
import UploadLink from '../UploadDocuments/UploadLink';
import * as action from './store/SupportingDocument.action';
import { customStyles, colourWayOptions } from '../helper';
import Loader from '../Utility/Loader/Loader';

function AddSupportingLink({ show, handlePopup, data, referenceOptions }) {
  const [showLoader, setShowLoader] = useState(false);
  const childRef = useRef();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const reducerData = useSelector((reducerState) => reducerState);
  const { ColorLibraryDetails, SystemMastersDetails } = reducerData;
  const { placement_master } = SystemMastersDetails;
  const { ColorLibList } = ColorLibraryDetails;
  const [radioSelected, setRadioSelected] = useState(false);
  const [showColourWayError, setShowColourWayError] = useState(false);
  const [qualitySelected, setQualitySelected] = useState(true);
  const [colourWays, setColourWays] = useState(null);
  const [reference, setReference] = useState(null);
  const [placement, setPlacement] = useState(null);

  const forms = (uploadedDoc) => {
    const obj = {};
    obj.fileName = uploadedDoc.linkName;
    obj.linkUrl = uploadedDoc?.linkUrl;
    obj.libId = data?.libId ? data?.libId : null;
    obj.bomType = data?.bomType;
    obj.documentType = 'link';
    obj.bomId = data?.bomId ? data?.bomId : null;

    obj.placement = placement?._id || null;
    obj.reference = reference || null;

    obj.docType = radioSelected ? t('ADD_SUPPORTING_FILE.COLOUR') : t('ADD_SUPPORTING_FILE.QUALITY');
    obj.colourWay = radioSelected ? colourWays?._id : null;
    if (data?.devOrderId) {
      obj.devOrderId = data?.devOrderId ? data?.devOrderId : null;
    }
    return obj;
  };

  const addDocument = async () => {
    if (childRef?.current) {
      const LinkAdded = await childRef.current.selectedDocument();
      if (LinkAdded) {
        if ((radioSelected && !isEmpty(colourWays?._id)) || !radioSelected) {
          setShowLoader(true);
          const obj = forms(LinkAdded);
          const res = await dispatch(action.saveDocuments(obj, t));
          setShowLoader(false);
          if (res) {
            handlePopup(true);
          }
        } else {
          setShowColourWayError(true);
        }
      }
    }
  };

  const handleRadioButton = async (e) => {
    if (e.target.id === 'status_Colour') {
      setRadioSelected(e.target.checked);
      setQualitySelected(!e.target.checked);
    } else {
      setRadioSelected(!e.target.checked);
      setQualitySelected(e.target.checked);
    }
  };

  const handleColourWays = (ele) => {
    setColourWays(ele);
    setShowColourWayError(false);
  };

  const handleReference = (ele) => {
    setReference(ele);
  };

  const handlePlacement = (ele) => {
    setPlacement(ele);
  };

  const validReferenceOptions = useMemo(() => {
    if (referenceOptions?.length) {
      return referenceOptions.some((option) => !option?.name) ? [] : referenceOptions;
    }
    return [];
  }, [referenceOptions]);

  return (
    <div>
      <form className="" noValidate autoComplete="off">
        <Modal
          show={show}
          size="md"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          className="common-custom-modal upload-doc-modal support-doc-modal"
        >
          <Modal.Header className="modal-header-custom">
            <Modal.Title id="contained-modal-title-vcenter">
              <span>{t('ADD_SUPPORTING_FILE.MODAL_TITLE')}</span>
            </Modal.Title>
            <span onClick={handlePopup} className="icon-close common-close-icon ml-auto cursor-pointer" />
          </Modal.Header>
          <Modal.Body className="common-upload-body">
            {showLoader ? (
              <Loader />
            ) : (
              <>
                <UploadLink ref={childRef} />

                <Row className="form-row-link">
                  <Col lg={3}>
                    <div className="text-bold f-14">{t('ADD_SUPPORTING_FILE.SUPPORTING_DOC_TYPE')}</div>
                    <div className="mt-2 d-flex ">
                      <div className="custom-radio d-flex">
                        <input type="radio" id="status_Quality" value={qualitySelected} onChange={handleRadioButton} checked={qualitySelected} />
                        <label className="mb-0" htmlFor="status_Quality" />
                      </div>
                      {t('ADD_SUPPORTING_FILE.QUALITY')}
                      <div className="custom-radio d-flex ml-3">
                        <input type="radio" id="status_Colour" value={radioSelected} onChange={handleRadioButton} checked={radioSelected} />
                        <label className="mb-0" htmlFor="status_Colour" />
                      </div>
                      {t('ADD_SUPPORTING_FILE.COLOUR')}
                    </div>
                  </Col>
                  {radioSelected && (
                    <Col lg={3}>
                      <div className="common-react-select">
                        <p className="asterisk-req text-bold support-doc-title">
                          {t('ADD_SUPPORTING_FILE.COLOURWAY')} <span>*</span>
                        </p>
                        <Select
                          name="colourWays"
                          options={colourWayOptions([...ColorLibList])}
                          getOptionLabel={(option) => `${option.refName}`}
                          getOptionValue={(option) => `${option._id}`}
                          value={colourWays}
                          styles={customStyles}
                          onChange={(e) => handleColourWays(e)}
                          placeholder={t('ADD_SUPPORTING_FILE.COLOURWAY')}
                          className="common-select"
                          classNamePrefix="common-select"
                        />
                      </div>
                      {showColourWayError && <span className="error-message">{t('ADD_SUPPORTING_FILE.UTILITY.ERROR_MESSAGES.COLOURWAY_REQUIRED')}</span>}
                    </Col>
                  )}
                  <Col lg={5} className="d-flex">
                    <div className="w-100 common-react-select">
                      <p className=" asterisk-req text-bold support-doc-title">{t('ADD_SUPPORTING_DOCUMENT.REFERENCE')}</p>

                      <Select
                        name={t('ADD_SUPPORTING_FILE.REFERENCE')}
                        options={validReferenceOptions}
                        getOptionLabel={(option) => `${option.name}`}
                        getOptionValue={(option) => `${option._id}`}
                        value={reference}
                        styles={customStyles}
                        onChange={(e) => handleReference(e)}
                        placeholder={t('ADD_SUPPORTING_DOCUMENT.REFERENCE')}
                        isClearable
                        className="common-select"
                        classNamePrefix="common-select"
                      />
                    </div>
                    <div className="pl-2 w-100 common-react-select">
                      <p className="asterisk-req text-bold support-doc-title">{t('ADD_SUPPORTING_DOCUMENT.PLACEMENT')}</p>

                      <Select
                        name={t('ADD_SUPPORTING_FILE.PLACEMENT')}
                        options={placement_master}
                        getOptionLabel={(option) => `${option.refName}`}
                        getOptionValue={(option) => `${option._id}`}
                        value={placement}
                        styles={customStyles}
                        onChange={(e) => handlePlacement(e)}
                        placeholder={t('ADD_SUPPORTING_DOCUMENT.PLACEMENT')}
                        isClearable
                        className="common-select"
                        classNamePrefix="common-select"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="modal-buttons d-flex justify-content-end">
                  <button aria-label="add" className="btn support-add" type="button" onClick={addDocument}>
                    <i className="icon-Tick-1" />
                  </button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      </form>
    </div>
  );
}

export default AddSupportingLink;
